module.exports = __webpack_public_path__ + "static/media/book-mock-en.a14be43b.png";